import React from 'react';
import { makeStyles } from '@mui/styles';
import { motion } from 'framer-motion';
import { Grid } from '@mui/material';

export const RecommendationResponse = (props) => {

    const { action, options } = props;
    const classes = useStyles();

    return (
        <Grid container justifyContent='center' alignItems='end' pt={ 2 }>
            {
                options?.map(o => (
                    <Grid key={ o } item xs={ 1 } sm={ 1 } md={ 1 } lg={ 1 } justifyContent='center'>
                        <div className={ classes.containerItem } onClick={ () => action(Number(o)) }>
                            { o == 0 && <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 1 }} className={ `${ classes.standart } ${ classes.cero }` }></motion.div> }
                            { o == 1 && <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 1 }} className={ `${ classes.standart } ${ classes.one }` }></motion.div> }
                            { o == 2 && <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 1 }} className={ `${ classes.standart } ${ classes.two }` }></motion.div> }
                            { o == 3 && <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 1 }} className={ `${ classes.standart } ${ classes.tree }` }></motion.div> }
                            { o == 4 && <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 1 }} className={ `${ classes.standart } ${ classes.four }` }></motion.div> }
                            { o == 5 && <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 1 }} className={ `${ classes.standart } ${ classes.five }` }></motion.div> }
                            { o == 6 && <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 1 }} className={ `${ classes.standart } ${ classes.six }` }></motion.div> }
                            { o == 7 && <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 1 }} className={ `${ classes.standart } ${ classes.seven }` }></motion.div> }
                            { o == 8 && <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 1 }} className={ `${ classes.standart } ${ classes.eight }` }></motion.div> }
                            { o == 9 && <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 1 }} className={ `${ classes.standart } ${ classes.nine }` }></motion.div> }
                            { o == 10 && <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 1 }} className={ `${ classes.standart } ${ classes.ten }` } />}
                            <span className={ classes.numberText }>{ o }</span>
                        </div>
                    </Grid>
                ))
            }
        </Grid>
    )
}

const useStyles = makeStyles({
    containerItem: {
        display: 'flex', 
        flexFlow: 'column noWrap', 
        alignItems: 'center', 
        gap: 10
    },
    standart: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff  !important',
        fontWeight: 'bold !important',
		border: '2px solid #fff !important',
		letterSpacing: '2px !important',
        cursor: 'pointer',
        borderRadius: 4,
        width: 'clamp(1em, 5vw, 2.5em)'
    },
    numberText: {
        color: '#fff',
        fontSize: 'clamp(1rem, 4vw, 1.5rem)'
    },
    cero: {
        background: '#c00000',
        height: 'calc(3vw + 0em)'
    },
    one: {
        background: '#ce2307',
        height: 'calc(3.5vw + 0em)'
    },
    two: {
        background: '#de2e03',
        height: 'calc(4vw + 0em)'
    },
    tree: {
        background: '#db3210',
        height: 'calc(4vw + .5em)'
    },
    four: {
        background: '#ff6d2a',
        height: 'calc(4vw + 1em)'
    },
    five: {
        background: '#ff9800',
        height: 'calc(4vw + 1.5em)'
    },
    six: {
        background: '#a9e159',
        height: 'calc(4vw + 2em)'
    },
    seven: {
        background: '#66c00b',
        height: 'calc(4vw + 2.5em)'
    },
    eight: {
        background: '#009929',
        height: 'calc(4vw + 3em)'
    },
    nine: {
        background: '#006414',
        height: 'calc(4vw + 3.5em)'
    },
    ten: {
        background: '#003400',
        height: 'calc(4vw + 4em)'
    }
});